import { useNavigate } from "react-router-dom";

const Subscribe = () => {
    const navigate = useNavigate();

    const handleSubscribe = () => {
        navigate("/contact");
    };

    return (
        <>
            <div
                className="container-fluid"
                style={{ background: "#73eda8ff" }}
            >
                <div
                    className="container d-flex justify-content-center align-items-center"
                    style={{ height: "40vh" }}
                >
                    <div className="text-center">
                        <h1
                            style={{
                                fontWeight: "700",
                                color: "black",
                                textAlign: "center",
                            }}
                        >
                            Access to the VIP Lounge
                        </h1>

                        <h5
                            style={{
                                fontWeight: "600",
                                color: "black",
                                textAlign: "center",
                            }}
                        >
                            Be a member for Exclusive Offers and Giveaways
                        </h5>

                        <button
                            className="mt-3 subcription-btn p-2"
                            onClick={handleSubscribe}
                        >
                            Subscribe
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Subscribe;
